import React from 'react';
import { Link as LinkR, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Badge,
  MenuItem,
  Menu,
  Typography,
  Link,
} from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import logo from '../../assets/logo1.png';
import useStyles from './styles';

const Navbar = ({ totalItems }) => {
  const classes = useStyles();
  const location = useLocation();

  return (
    <>
      <AppBar
        style={{
          background: 'white',
          position: 'relative',
        }}
        position='fixed'
        className={classes.appBar}
        color='inherit'
      >
        <Toolbar>
          <Link href='http://beastmodebattles.netlify.app'>
            <img
              src={logo}
              alt='BeastMode Battles'
              height='50px'
              width='75px'
              style={{ padding: '0' }}
              className={classes.image}
            />
          </Link>

          <Typography
            component={LinkR}
            to='/'
            variant='h6'
            className={classes.title}
            color='black'
          >
            BeastMODE Store
          </Typography>

          <div className={classes.grow} />
          {location.pathname === '/' && (
            <div className={classes.button}>
              <IconButton
                component={LinkR}
                to='/cart'
                aria-label='Show cart items'
                color='white'
              >
                <Badge badgeContent={totalItems} color='secondary'>
                  <ShoppingCart />
                </Badge>
              </IconButton>
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
